import { render, staticRenderFns } from "./batchActivateImport.vue?vue&type=template&id=477a1a0a&scoped=true&"
import script from "./batchActivateImport.vue?vue&type=script&lang=js&"
export * from "./batchActivateImport.vue?vue&type=script&lang=js&"
import style0 from "./batchActivateImport.vue?vue&type=style&index=0&id=477a1a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a1a0a",
  null
  
)

export default component.exports